import Service, { getCallApiFunction } from '../service'
// import denormalizer from './denormalizer'
// import normalizer from './normalizer'

class FetchMemberDataApi extends Service {
  constructor() {
    super()
    this.name = 'FETCH_MEMBER_DATA'

    this.config = {
      url: `/v1/member/profile`,
      method: 'GET',
      params: { cache: 0 }, // 避免拿到 CDN/gateway 快取的舊資料
    }
  }
}

export const fetchMemberData = () => getCallApiFunction(new FetchMemberDataApi())
